import { useEffect } from "react";
import { useRouteMatch, Switch, Route } from "react-router";
import AgeChecker from "./AgeChecker";
import { useDispatch, useSelector } from "react-redux";
import { IneligibleScreen } from "../ResultScreens";
import usePostcodeCheck from "../../../hooks/usePostcodeCheck";
import { EligibilityCheckerPageProps, ProgrammeProps } from "../Props";
import { PowerOfTen, ProgressStepEnum, setStepProgress } from "../../../../redux/slices/progressBarSlice";

interface AgeCheckerRootProps extends ProgrammeProps {
  pageData: {
    ineligibleScreen: EligibilityCheckerPageProps;
  };
  existingDob: Date | null;
  progressPercentage?: PowerOfTen;
}

const AgeIneligibleScreen = ({ title, heading, body }: Readonly<EligibilityCheckerPageProps>) => {
  const [response, getPostcodeChecked] = usePostcodeCheck();
  const storePostcode = useSelector((state: any) => state.signupFlowData.signupFormValues?.postcode);

  useEffect(() => {
    getPostcodeChecked(storePostcode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IneligibleScreen
      title={title}
      heading={heading}
      bodyText={body.replace("{{serviceAgeCriteria}}", response.data?.eligibilityCriteria.minimumAge)}
      hasContactUs={true}
    />
  );
};

function AgeCheckerRoot({
  programmeTitle,
  pageData,
  existingDob,
  progressPercentage,
}: Readonly<AgeCheckerRootProps>) {
  let { path } = useRouteMatch();
  const dispatch = useDispatch();

  useEffect(() => {
    if (progressPercentage) {
      dispatch(
        setStepProgress({
          progressStepEnum: ProgressStepEnum.CheckEligiblity,
          progressPercentage: progressPercentage,
        })
      );
    }
  }, [dispatch, progressPercentage]);

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <AgeChecker programmeTitle={programmeTitle} existingDob={existingDob} />
      </Route>
      <Route path={`${path}/fail`}>
        <AgeIneligibleScreen {...pageData.ineligibleScreen} />
      </Route>
    </Switch>
  );
}

export default AgeCheckerRoot;
